import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { TdUI } from './ui';

export class Td extends PureComponent {
    static displayName = 'TdContainer';

    render() {
        const { ...rest } = this.props;

        // PUT OTHER PROPS AFTER {...rest}
        return <TdUI {...rest} />;
    }
}

export const TdContainer = compose()(Td);
